import { render, staticRenderFns } from "./create-nbn-order.vue?vue&type=template&id=1175d31a&scoped=true"
import script from "./create-nbn-order.vue?vue&type=script&lang=js"
export * from "./create-nbn-order.vue?vue&type=script&lang=js"
import style0 from "./create-nbn-order.vue?vue&type=style&index=0&id=1175d31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175d31a",
  null
  
)

export default component.exports